/** @typedef {import("../hooks/entitlex/useEntitlexData").EntitlexApiOperation} EntitlexApiOperation*/

export const entitlexService = {
  /** @returns {EntitlexApiOperation} */
  init: () => async (entitlex) => {
    const [isAvailable, hasAdminAccess] = await Promise.all([
      entitlex.utility.isAvailable(),
      entitlex.utility.hasAdminAccess()
    ])
    return {
      isAvailable,
      hasAdminAccess
    }
  },

  /**
   * @param {string|undefined} email
   * @returns {EntitlexApiOperation}
   */
  getUserApplications: (email) => async (entitlex) => {
    if (email) {
      return await entitlex.user.applications.get(email)
    }
  },

  /**
   * @param {string|undefined} application
   * @returns {EntitlexApiOperation}
   */
  getUserApplicationPermissions: (application) => async (entitlex) => {
    if (application) {
      return await entitlex.permissions.get(application)
    }
  },

  /**
   * @param {string|undefined} listHref
   * @returns {EntitlexApiOperation}
   */
  getListContent: (listHref) => async (entitlex) => {
    if (listHref) {
      return await entitlex.permissions.getListContent(listHref)
    }
  }
}
